import { jsx, jsxs } from "react/jsx-runtime";
import { Badge } from "../common/index.js";
import { EllipsisText } from "../../EllipsisText/index.js";
import { Box } from "../../Box/index.js";
import { Typography } from "../../Typography/index.js";
import { Tooltip } from "../../Tooltip/index.js";
import { Checkbox } from "../../Checkbox/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function dropdownOption_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else dropdownOption_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const COLORS = {
    gray: 'stroke.primary',
    darkgray: 'stroke.secondary',
    green: 'accent.stroke.success',
    orange: 'accent.stroke.warning',
    purple: 'accent.stroke.review',
    blue: 'accent.stroke.blue',
    red: 'accent.stroke.error'
};
const renderTwoLineOption = (option)=>{
    const [subtitle, titleFirst, titleSecond] = option.label.split(', ');
    const { badge } = option;
    const isBottom = (null == badge ? void 0 : badge.position) === 'bottom';
    let title = '';
    if (subtitle && !titleFirst) title = subtitle;
    else {
        const titleSecondFormatted = titleSecond ? `, ${titleSecond}` : '';
        title = `${titleFirst || ''}${titleSecondFormatted}`;
    }
    return /*#__PURE__*/ jsxs(Box, {
        py: badge ? '8' : '12',
        children: [
            title && /*#__PURE__*/ jsx(Box, {
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body3",
                    children: title
                })
            }),
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                gap: "8",
                mt: "4",
                children: [
                    badge && /*#__PURE__*/ jsx(Box, {
                        children: /*#__PURE__*/ jsx(Badge, {
                            title: badge.title,
                            description: badge.description,
                            color: badge.color
                        })
                    }),
                    title !== subtitle && /*#__PURE__*/ jsx(Box, {
                        order: isBottom ? 0 : 1,
                        children: /*#__PURE__*/ jsx(Typography, {
                            component: "div",
                            variant: title ? 'caption' : 'body3',
                            color: "text.light.tertirary",
                            children: subtitle
                        })
                    })
                ]
            })
        ]
    });
};
const renderOptionWithBadge = (option)=>{
    const { badge, label } = option;
    return /*#__PURE__*/ jsx(Box, {
        py: badge ? '8' : '12',
        children: /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            gap: "8",
            mt: "4",
            children: [
                badge && /*#__PURE__*/ jsx(Box, {
                    children: /*#__PURE__*/ jsx(Badge, {
                        title: badge.title,
                        description: badge.description,
                        color: badge.color
                    })
                }),
                /*#__PURE__*/ jsx(Box, {
                    children: /*#__PURE__*/ jsx(Typography, {
                        component: "div",
                        variant: "body3",
                        color: "text.light.primary",
                        children: label
                    })
                })
            ]
        })
    });
};
const renderTwoLineOptionEllipsis = (option)=>{
    const [title, ...rest] = option.label.split(',');
    return /*#__PURE__*/ jsx(Box, {
        py: "12",
        children: /*#__PURE__*/ jsx(Tooltip, {
            disabled: !(null == option ? void 0 : option.tooltipText),
            title: option.tooltipText || '',
            placement: "right",
            children: /*#__PURE__*/ jsxs(Box, {
                children: [
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "body3",
                        children: title
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        mt: "2",
                        children: /*#__PURE__*/ jsx(Typography, {
                            variant: "caption",
                            color: "text.light.tertirary",
                            children: /*#__PURE__*/ jsx(EllipsisText, {
                                children: null == rest ? void 0 : rest.join(', ')
                            })
                        })
                    })
                ]
            })
        })
    });
};
const renderTwoLineWithJoinedTitleAndSubtitle = (option)=>{
    const [title, subtitle, ...rest] = option.label.split(',');
    return /*#__PURE__*/ jsxs(Box, {
        py: "12",
        children: [
            /*#__PURE__*/ jsx(Box, {
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body3",
                    children: [
                        title,
                        subtitle
                    ].join(', ')
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                mt: "2",
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "caption",
                    color: "text.light.tertirary",
                    children: /*#__PURE__*/ jsx(EllipsisText, {
                        children: null == rest ? void 0 : rest.join(', ')
                    })
                })
            })
        ]
    });
};
const renderLineOptionWithTooltip = (option, tooltipProps)=>{
    const { label } = option;
    return /*#__PURE__*/ jsx(Tooltip, _object_spread_props(_object_spread({
        placement: "right",
        title: label
    }, tooltipProps), {
        children: /*#__PURE__*/ jsx(Box, {
            py: "12",
            children: /*#__PURE__*/ jsx(Box, {
                py: "2",
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body3",
                    children: /*#__PURE__*/ jsx(EllipsisText, {
                        rows: 1,
                        children: label
                    })
                })
            })
        })
    }));
};
const renderLineOptionWithDisabledItemAndTooltip = (option)=>{
    const { disabled, label, tooltipText } = option;
    if (disabled && tooltipText) return /*#__PURE__*/ jsx(Box, {
        children: /*#__PURE__*/ jsx(Tooltip, {
            title: tooltipText,
            placement: "right",
            children: /*#__PURE__*/ jsx(Box, {
                py: "12",
                px: "16",
                display: "inline-block",
                cursor: "pointer",
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body3",
                    color: "text.light.tertirary",
                    children: /*#__PURE__*/ jsx(EllipsisText, {
                        rows: 1,
                        children: label
                    })
                })
            })
        })
    });
    return /*#__PURE__*/ jsx(Box, {
        py: "8",
        children: /*#__PURE__*/ jsx(Typography, {
            variant: "body3",
            children: label
        })
    });
};
const renderTwoLineOptionWithSeparateSubtitle = (option)=>{
    const { subtitle, label } = option;
    return /*#__PURE__*/ jsxs(Box, {
        py: "12",
        children: [
            /*#__PURE__*/ jsx(Box, {
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body3",
                    children: label
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                gap: "8",
                mt: "4",
                children: /*#__PURE__*/ jsx(Box, {
                    children: /*#__PURE__*/ jsx(Typography, {
                        component: "div",
                        variant: "caption",
                        color: "text.light.tertirary",
                        children: subtitle
                    })
                })
            })
        ]
    });
};
const renderTwoLineOptionWithNodeLabelAndSubtitle = ({ label, subtitle })=>/*#__PURE__*/ jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ jsx(Box, {
                children: label
            }),
            /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "text.light.tertirary",
                children: subtitle
            })
        ]
    });
const renderTwoLineOptionWithDisabledTooltip = (option)=>{
    const { label, subtitle, disabled, tooltipText } = option;
    const content = /*#__PURE__*/ jsxs(Box, {
        py: "12",
        display: "flex",
        flexDirection: "column",
        gap: "4",
        cursor: disabled ? 'default' : 'pointer',
        children: [
            /*#__PURE__*/ jsx(Typography, {
                variant: "body3",
                color: disabled ? 'text.light.tertirary' : 'text.light.primary',
                children: /*#__PURE__*/ jsx(EllipsisText, {
                    rows: 1,
                    wordBreak: "break-all",
                    children: label
                })
            }),
            subtitle && /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "text.light.tertirary",
                children: subtitle
            })
        ]
    });
    if (disabled) return /*#__PURE__*/ jsx(Box, {
        flexGrow: 1,
        onClick: (e)=>e.stopPropagation(),
        children: /*#__PURE__*/ jsx(Tooltip, {
            title: tooltipText,
            children: content
        })
    });
    return content;
};
const renderOptionWithColoredIndicator = (option)=>{
    const { label, color } = option;
    return /*#__PURE__*/ jsxs(Box, {
        display: "flex",
        alignItems: "center",
        gap: "12",
        py: "12",
        children: [
            color && /*#__PURE__*/ jsx(Box, {
                width: 8,
                height: 8,
                bgcolor: COLORS[color],
                radius: "round"
            }),
            /*#__PURE__*/ jsx(Box, {
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body3",
                    children: label
                })
            })
        ]
    });
};
const renderCustomOptionWithHighlight = (option, currentValue)=>/*#__PURE__*/ jsx(Box, {
        display: "flex",
        alignItems: "start",
        gap: "12",
        py: "8",
        children: /*#__PURE__*/ jsx(Typography, {
            variant: "body3",
            color: option.value === currentValue ? 'accent.text.blue' : 'text.light.primary',
            children: option.label
        })
    });
const renderTwoLineOptionWithSubtitleAndCheckbox = (option, value)=>{
    const [titleFirst, subtitle, ...rest] = option.label.split(', ');
    const isDisabled = option.disabled;
    const tooltipText = option.tooltipText;
    const title = titleFirst;
    const formattedSubtitle = `${subtitle || ''}${!!rest.length ? `, ${rest.join(', ')}` : ''}`;
    const handleStopPropagination = (event)=>null == event ? void 0 : event.stopPropagation();
    if (isDisabled) return /*#__PURE__*/ jsxs(Box, {
        py: "12",
        display: "flex",
        alignItems: "center",
        onClick: handleStopPropagination,
        children: [
            /*#__PURE__*/ jsx(Checkbox, {
                withoutMargin: true,
                sizeVariant: "large",
                checked: !!value && value.some((item)=>item === option.value)
            }),
            /*#__PURE__*/ jsx(Tooltip, {
                title: tooltipText,
                placement: "right",
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    flexDirection: "column",
                    children: [
                        title && /*#__PURE__*/ jsx(Box, {
                            children: /*#__PURE__*/ jsx(Typography, {
                                variant: "body3",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                            gap: "8",
                            mt: "4",
                            children: title !== subtitle && /*#__PURE__*/ jsx(Box, {
                                order: 1,
                                children: /*#__PURE__*/ jsx(Typography, {
                                    component: "div",
                                    variant: title ? 'caption' : 'body3',
                                    color: "text.light.tertirary",
                                    children: formattedSubtitle
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ jsxs(Box, {
        py: "12",
        display: "flex",
        alignItems: "center",
        children: [
            /*#__PURE__*/ jsx(Box, {
                children: /*#__PURE__*/ jsx(Checkbox, {
                    withoutMargin: true,
                    sizeVariant: "large",
                    checked: !!value && value.some((item)=>item === option.value)
                })
            }),
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                flexDirection: "column",
                children: [
                    title && /*#__PURE__*/ jsx(Box, {
                        children: /*#__PURE__*/ jsx(Typography, {
                            variant: "body3",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: "8",
                        mt: "4",
                        children: title !== subtitle && /*#__PURE__*/ jsx(Box, {
                            order: 1,
                            children: /*#__PURE__*/ jsx(Typography, {
                                component: "div",
                                variant: title ? 'caption' : 'body3',
                                color: "text.light.tertirary",
                                children: formattedSubtitle
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const renderTwoLineOptionWithCheckbox = (option, value)=>{
    const [titleFirst, titleSecond, subtitle, ...rest] = option.label.split(', ');
    const { badge } = option;
    const isBadgePositionLeft = (null == badge ? void 0 : badge.position) === 'left';
    const isBadgeHasTitle = !!(null == badge ? void 0 : badge.title);
    const isDisabled = option.disabled;
    const tooltipText = option.tooltipText;
    let title = '';
    if (subtitle && !titleFirst) title = subtitle;
    else {
        const titleSecondFormatted = titleSecond ? `, ${titleSecond}` : '';
        title = `${titleFirst || ''}${titleSecondFormatted}`;
    }
    const formattedSubtitle = `${subtitle}${!!rest.length ? `, ${rest.join(', ')}` : ''}`;
    const handleStopPropagination = (event)=>null == event ? void 0 : event.stopPropagation();
    if (isDisabled) return /*#__PURE__*/ jsxs(Box, {
        py: "12",
        display: "flex",
        alignItems: "center",
        width: "100%",
        onClick: handleStopPropagination,
        children: [
            /*#__PURE__*/ jsx(Checkbox, {
                withoutMargin: true,
                sizeVariant: "large",
                checked: !!value && value.some((item)=>item === option.value)
            }),
            /*#__PURE__*/ jsx(Tooltip, {
                title: tooltipText,
                placement: "right",
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    children: [
                        title && /*#__PURE__*/ jsxs(Box, {
                            display: "flex",
                            alignItems: "center",
                            gap: "8",
                            children: [
                                badge && isBadgeHasTitle && isBadgePositionLeft && /*#__PURE__*/ jsx(Badge, {
                                    title: badge.title,
                                    description: badge.description,
                                    color: badge.color
                                }),
                                /*#__PURE__*/ jsx(Typography, {
                                    variant: "body3",
                                    children: title
                                })
                            ]
                        }),
                        title !== subtitle && /*#__PURE__*/ jsx(Box, {
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                            gap: "8",
                            mt: "4",
                            children: /*#__PURE__*/ jsx(Box, {
                                order: 1,
                                children: /*#__PURE__*/ jsx(Typography, {
                                    component: "div",
                                    variant: title ? 'caption' : 'body3',
                                    color: "text.light.tertirary",
                                    children: formattedSubtitle
                                })
                            })
                        }),
                        badge && isBadgeHasTitle && !isBadgePositionLeft && /*#__PURE__*/ jsx(Box, {
                            mt: "4",
                            children: /*#__PURE__*/ jsx(Badge, {
                                title: badge.title,
                                description: badge.description,
                                color: badge.color
                            })
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ jsxs(Box, {
        py: "12",
        display: "flex",
        alignItems: "center",
        width: "100%",
        children: [
            /*#__PURE__*/ jsx(Box, {
                children: /*#__PURE__*/ jsx(Checkbox, {
                    withoutMargin: true,
                    sizeVariant: "large",
                    checked: !!value && value.some((item)=>item === option.value)
                })
            }),
            /*#__PURE__*/ jsx(Tooltip, {
                disabled: !tooltipText,
                title: tooltipText,
                placement: "right",
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    children: [
                        title && /*#__PURE__*/ jsxs(Box, {
                            display: "flex",
                            alignItems: "center",
                            gap: "8",
                            children: [
                                badge && isBadgeHasTitle && isBadgePositionLeft && /*#__PURE__*/ jsx(Badge, {
                                    title: badge.title,
                                    description: badge.description,
                                    color: badge.color
                                }),
                                /*#__PURE__*/ jsx(Typography, {
                                    variant: "body3",
                                    children: title
                                })
                            ]
                        }),
                        subtitle && title !== subtitle && /*#__PURE__*/ jsx(Box, {
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                            gap: "8",
                            mt: "4",
                            children: /*#__PURE__*/ jsx(Box, {
                                order: 1,
                                children: /*#__PURE__*/ jsx(Typography, {
                                    component: "div",
                                    variant: title ? 'caption' : 'body3',
                                    color: "text.light.tertirary",
                                    children: /*#__PURE__*/ jsx(EllipsisText, {
                                        children: formattedSubtitle
                                    })
                                })
                            })
                        }),
                        badge && isBadgeHasTitle && !isBadgePositionLeft && /*#__PURE__*/ jsx(Box, {
                            mt: "4",
                            children: /*#__PURE__*/ jsx(Badge, {
                                title: badge.title,
                                description: badge.description,
                                color: badge.color
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const renderOptionWithIcon = (option)=>{
    const { label, startIcon } = option;
    return /*#__PURE__*/ jsxs(Box, {
        display: "flex",
        alignItems: "center",
        gap: "12",
        py: "12",
        children: [
            startIcon && startIcon,
            /*#__PURE__*/ jsx(Box, {
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body3",
                    children: label
                })
            })
        ]
    });
};
export { renderCustomOptionWithHighlight, renderLineOptionWithDisabledItemAndTooltip, renderLineOptionWithTooltip, renderOptionWithBadge, renderOptionWithColoredIndicator, renderOptionWithIcon, renderTwoLineOption, renderTwoLineOptionEllipsis, renderTwoLineOptionWithCheckbox, renderTwoLineOptionWithDisabledTooltip, renderTwoLineOptionWithNodeLabelAndSubtitle, renderTwoLineOptionWithSeparateSubtitle, renderTwoLineOptionWithSubtitleAndCheckbox, renderTwoLineWithJoinedTitleAndSubtitle };
